import { Component, forwardRef, Input, OnInit } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";

interface Option {
  label: string;
  value: any;
}

export const FILTERS_PICKER_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => FiltersPickerComponent),
  multi: true,
};

@Component({
  selector: "host-filters-picker",
  templateUrl: "./filters-picker.component.html",
  styleUrls: ["./filters-picker.component.scss"],
  providers: [FILTERS_PICKER_VALUE_ACCESSOR],
})
export class FiltersPickerComponent implements OnInit, ControlValueAccessor {
  @Input() listOfOption = [];

  value: Set<any> = new Set([]);
  _registerOnChange: (value: any) => void = (r: any) => {};
  constructor() {}

  ngOnInit() {}

  registerOnChange(fn: any): void {
    this._registerOnChange = fn;
  }

  registerOnTouched(fn: any): void {}

  writeValue(value: any[] = []) {
    this.value = new Set(value);
  }

  onClickItem(item: Option) {
    const { value } = item;
    if (this.value.has(value)) {
      this.value.delete(value);
    } else {
      this.value.add(value);
    }

    this._registerOnChange(Array.from(this.value));
  }
}
